import $ from 'jquery';

/**
 * @returns {HTMLElement}
 */
function getSearchButton() {
  return document.getElementById('search');
}

/**
 *
 * @param {Event} event
 */
function onClick(event) {
  var btn = event.currentTarget;
  if (btn.getAttribute('aria-expanded') === 'false') {
    // open
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('js-search-open');
    document.getElementById('search-bar__input').focus();
  } else {
    // close
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('js-search-open');
  }
}

/**
 *
 * @param {Event} event
 */
function onClose(event) {
  console.log('close');
  getSearchButton().setAttribute('aria-expanded', 'false');
  document.documentElement.classList.remove('js-search-open');
}

$(function () {

  // button in header
  var btn = getSearchButton()
  btn.addEventListener('click', onClick);

  // button in search bar
  var close = document.getElementById('search-bar__close');
  close.addEventListener('click', onClose);
});
